import { render, staticRenderFns } from "./AddRevenueOutClassDialog.vue?vue&type=template&id=2589617e&scoped=true"
import script from "./AddRevenueOutClassDialog.vue?vue&type=script&lang=js"
export * from "./AddRevenueOutClassDialog.vue?vue&type=script&lang=js"
import style0 from "./AddRevenueOutClassDialog.vue?vue&type=style&index=0&id=2589617e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589617e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2589617e')) {
      api.createRecord('2589617e', component.options)
    } else {
      api.reload('2589617e', component.options)
    }
    module.hot.accept("./AddRevenueOutClassDialog.vue?vue&type=template&id=2589617e&scoped=true", function () {
      api.rerender('2589617e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/AddRevenueOutClassDialog.vue"
export default component.exports